import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import axios from 'axios';
import { HomeHero } from '../components/HomeHero';
import { HomeCollections } from '../components/HomeCollections';
import { HomeBrandStory } from '../components/HomeBrandStory';
import { ProductCard } from '../components/ProductCard';
import { BlurFade } from '../components/magicui/blur-fade';
import { useCart } from '../context/CartContext';
import { toast } from '../hooks/use-toast';
import { API, collectionLabels } from '../lib/catalog';

const selectedIds = ['maxlight-p0623d', 'maxlight-p0509', 'maxlight-t0065', 'maxlight-w0338'];

export default function HomePage() {
  const [collections, setCollections] = useState(Object.entries(collectionLabels).map(([id, name]) => ({ id, name })));
  const [featured, setFeatured] = useState([]);
  const { addToCart } = useCart();
  useEffect(() => {
    const controller = new AbortController();
    axios.get(`${API}/catalog/products`, { params: { page_size: 1 }, signal: controller.signal })
      .then(r => setCollections(r.data.collections)).catch(() => {});
    Promise.all(selectedIds.map(id => axios.get(`${API}/products/${id}`, { signal: controller.signal }).then(r => r.data)))
      .then(setFeatured).catch(() => {});
    return () => controller.abort();
  }, []);
  const add = p => { addToCart(p); toast({ title: 'Dodano u košaricu', description: p.name }); };
  return <div data-testid="premium-home">
    <HomeHero />
    <HomeCollections collections={collections} />
    {featured.length > 0 && <section className="premium-section premium-featured" data-testid="home-featured">
      <div className="premium-container">
        <div className="premium-section-heading"><div><p className="premium-eyebrow">Odabrano iz kolekcije</p><h2 data-testid="home-featured-title">Detalji koji čine razliku.</h2></div><Link className="premium-text-link" to="/webshop" data-testid="home-featured-all">Cijela ponuda <ArrowUpRight size={16} /></Link></div>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">{featured.map((p, i) => <BlurFade key={p.id} delay={i * 0.04}><ProductCard product={p} onAdd={add} /></BlurFade>)}</div>
      </div>
    </section>}
    <HomeBrandStory />
    <section className="premium-contact-band" data-testid="home-contact-band"><div className="premium-container">
      <div><h2 data-testid="home-contact-heading">Pravo svjetlo počinje razgovorom.</h2><p data-testid="home-contact-description">Za vaš dom, interijer ili sljedeći projekt.</p></div>
      <Link to="/kontakt" className="magic-shimmer-button" data-testid="home-contact-cta"><span className="magic-shimmer-content">Razgovarajmo o rasvjeti <ArrowUpRight size={17} /></span></Link>
    </div></section>
  </div>;
}